module.exports = __webpack_public_path__ + "img/auth1.6649591f.png";